<template>
  <div>
    <!-- Side Menu -->
    <div class="side-menu" :class="{ open: isMenuOpen }">
      <ul>
        <li class="menu-header">
          <i class="fas fa-home" />
          <RouterLink to="/"> Utama </RouterLink>
        </li>
        <li>
          <RouterLink to="pbt"> PBT </RouterLink>
        </li>
        <li>
          <RouterLink to="ahli-pbt"> Ahli Majlis PBT </RouterLink>
        </li>
        <li>
          <RouterLink to="pasar-pbt"> Pasar Sementara </RouterLink>
        </li>
        <li>
          <RouterLink to="pbtcare"> PBTCare </RouterLink>
        </li>
        <li>
          <RouterLink to="pasar-awam"> Pasar Awam PBT </RouterLink>
        </li>
        <li>
          <RouterLink to="kesihatan">Premis Makanan </RouterLink>
        </li>
        <li>
          <RouterLink to="haiwan-terbiar"> Haiwan Terbiar </RouterLink>
        </li>
        <li>
          <RouterLink to="sanitasi"> Sanitasi dan Disinfeksi </RouterLink>
        </li>
        <li>
          <RouterLink to="vektor"> Vektor </RouterLink>
        </li>
        <li>
          <RouterLink to="kempen"> Kempen </RouterLink>
        </li>
        <li>
          <RouterLink to="tandas-awam"> Tandas Awam PBT </RouterLink>
        </li>
        <li>
          <RouterLink to="oku"> Parkir OKU </RouterLink>
        </li>
        <li>
          <RouterLink to="spah"> SPAH, Cerun, Jalan </RouterLink>
        </li>
        <li>
          <RouterLink to="cctv"> CCTV </RouterLink>
        </li>
        <li>
          <RouterLink to="lampu-jalan"> Lampu Jalan </RouterLink>
        </li>
        <li>
          <RouterLink to="fogt"> FOGT </RouterLink>
        </li>
        <li>
          <RouterLink to="kolam-renang"> Kolam Renang </RouterLink>
        </li>
        <li>
          <RouterLink to="osc"> OSC 3.0 Plus </RouterLink>
        </li>
        <li>
          <RouterLink to="pbtPay"> PBTPay </RouterLink>
        </li>
        <li>
          <RouterLink to="e-book"> E-Book </RouterLink>
        </li>
      </ul>
    </div>
    <div v-if="isMenuOpen" class="overlay" @click="toggleMenu" />
    <button v-if="!isMenuOpen" class="menu-toggle-button" @click="toggleMenu">
      <i class="fas fa-home" />
    </button>
  </div>
</template>

<script setup>
import { ref } from "vue";

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
</script>

<style scoped>
/* Side Menu */
.side-menu {
  position: fixed;
  top: 20%;
  right: 0;
  width: 200px;
  height: 50%; /* fixed height */
  overflow-y: auto; /* enable scroll */
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;
}

.side-menu.open {
  transform: translateX(0);
}

.side-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.side-menu li {
  margin-bottom: 10px;
}

.side-menu li:last-child {
  margin-bottom: 30px; /* Add extra space below the last menu item */
}

.side-menu a,
.side-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Menu Toggle Button */
.menu-toggle-button {
  position: fixed;
  top: 20%;
  right: 0;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 10px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1001;
  transition: right 0.3s;
}

.menu-toggle-button i {
  font-size: 1.5rem;
}

.menu-toggle-button:hover {
  right: 5px;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}

/* 1024px */
@media (max-width: 1024px) {
  .side-menu {
    inline-size: 180px;
    inset-block-start: 15%;
    max-block-size: 80%;
  }

  .menu-toggle-button {
    inset-block-start: 15%;
    padding: 8px;
  }

  .menu-header {
    font-size: 1.1rem;
  }
}

/* 768px */
@media (max-width: 768px) {
  .side-menu {
    inline-size: 160px;
    inset-block-start: 15%;
    max-block-size: 90%;
  }

  .menu-toggle-button {
    inset-block-start: 15%;
    font-size: 1.3rem;
  }

  .menu-header {
    font-size: 1rem;
  }

  .side-menu li {
    font-size: 0.9rem;
  }
}

/* 480px */
@media (max-width: 480px) {
  .side-menu {
    inline-size: 140px;
    inset-block-start: 12%;
    max-block-size: 95%;
    padding-inline: 10px;
  }

  .menu-toggle-button {
    inset-block-start: 12%;
    font-size: 1.2rem;
  }

  .menu-header {
    font-size: 0.9rem;
  }

  .side-menu li {
    font-size: 0.8rem;
  }
}
</style>
